import type {ReactElement} from 'react';
import {useAiChat} from '@AiChat/providers/ai-chat.context';
import {useAiChatSize} from '@AiChat/hooks/useAiChatSize';
import {useAiChatSeason} from '@AiChat/hooks/useAiChatSeason';
import {AiChatSeason} from '@AiChat/lib/ai-chat-season-library.types';
import {AiChatHalloweenPumpkins} from '@AiChat/components/ai-chat-halloween-pumpkins/ai-chat-halloween-pumpkins';
import {AiChatChristmasBackdrop} from '@AiChat/components/ai-chat-christmas-backdrop/ai-chat-christmas-backdrop';
import {AiChatChristmasBackdropPlacement} from '@AiChat/components/ai-chat-christmas-backdrop/ai-chat-christmas-backdrop.types';
import {assertNever} from '@Utils/assert-never.util';
import styles from './ai-chat-seasonal-prompt-box-decorations.module.scss';

export function AiChatSeasonalPromptBoxDecorations(): ReactElement | null {
  const {state} = useAiChat();
  const {isSmall} = useAiChatSize();
  const season = useAiChatSeason();

  if (!season || !isSmall || !state.isReturningUser) {
    return null;
  }

  switch (season) {
    case AiChatSeason.HALLOWEEN:
      return <AiChatHalloweenPumpkins pumpkinSetClasses={styles.pumpkins} />;
    case AiChatSeason.CHRISTMAS:
      return <AiChatChristmasBackdrop placement={AiChatChristmasBackdropPlacement.PROMPT_BOX} />;
    default:
      return assertNever(season);
  }
}
